const stateWisePDFs = {
 karnataka: "/collegepdf/karnatkafeedetails.pdf",
 maharashtra: "/collegepdf/Maharastrafeedetails.pdf",
 bihar: "/collegepdf/Biharfeedetails.pdf",
 madhyapradesh: "/collegepdf/Madhyapradeshfeedetails.pdf",
 westbengal: "/collegepdf/westbengalfeedetails.pdf", //no colleges
 haryana: "/collegepdf/haryanafeedetails.pdf",
 rajasthan: "/collegepdf/rajashtanfeedetals.pdf",
 uttarpradesh: "/collegepdf/upfeedetails.pdf",
 uttarakhand: "/collegepdf/uttrakhandfeedetails.pdf",

 // Add more as needed
};

export default stateWisePDFs;
